import { BlinkErrorBoundary } from '@thoughtspot/mfe-utilities';
import { isPartitionedCookieEnabled } from '@thoughtspot/session-service';
import React, { useEffect, useMemo } from 'react';
import { useUpdateMessages } from "../../../services/coms/coms-service";
import { useGetUserAccessibleOrgsByParamsQuery } from "../../../services/orgs/orgs-service";
import { create } from "../../../utils/logger";
import { useBlinkContextForCOMS, useValidateBlinkContextForCOMS, } from '../../../contexts/coms-blink-context';
import { useHasProfilePic } from '../../../services/user/user-service';
import { UserMenuV3 } from './user-menu-v3';
const logger = create('user-menu-container');
const useForceUpdate = () => {
    const [, setState] = React.useState(false);
    return () => {
        setState(state => !state);
    };
};
export const UserMenuContainer = ({ inviteTeammates, onMenuClose, triggerV1Logout, useDoLogout, }) => {
    useValidateBlinkContextForCOMS();
    const { sessionService, navService, metricsService, systemConfigService, } = useBlinkContextForCOMS();
    const { error } = useUpdateMessages();
    const { data: orgsData } = useGetUserAccessibleOrgsByParamsQuery({
        batchsize: -1,
        offset: -1,
        pattern: '',
    });
    const numActiveOrgs = useMemo(() => {
        const orgs = orgsData?.Data?.orgs;
        if (orgs && Array.isArray(orgs)) {
            return orgs.filter((org) => org.isActive).length;
        }
        return 0;
    }, [orgsData]);
    const isOrgEnabled = sessionService.isOrgUiEnabled() &&
        !sessionService.hideOrgSwitcherUi() &&
        (!sessionService.showOrgSwitcherToUsersWithMultipleOrgs() ||
            numActiveOrgs > 1);
    const { isLoggedIn, setLast401Path, setSessionInfo, markManuallyLoggedOut, clearSessionInfo, getOnUserLoggedOut, getUserDisplayName, getUserGuid, onThirdPartyServicesInitiated, } = sessionService;
    const { getUrlHash, goToLogin, goToUserPreference } = navService;
    onThirdPartyServicesInitiated.subscribe(useForceUpdate());
    const { data: hasProfilePic } = useHasProfilePic(!isLoggedIn(), getUserGuid());
    const { doLogout } = useDoLogout();
    const currentPath = getUrlHash().replace('#/', '/');
    function removeOverrideOrgId(url) {
        let currentUrl = url;
        if (currentUrl.includes('orgId')) {
            const [baseUrl, hash] = currentUrl.split('#');
            const [basePath, queryString] = baseUrl.split('?');
            const queryStringWithoutOrgOverride = queryString.replace(/(?:&|^)orgId=[^&]*/, '');
            currentUrl = `${basePath}${queryStringWithoutOrgOverride
                ? `?${queryStringWithoutOrgOverride}`
                : ''}${hash ? `#${hash}` : ''}`;
            return currentUrl;
        }
        return currentUrl;
    }
    const shouldDoIAMv2Logout = () => {
        const issuerLink = systemConfigService.getOidcLoginUriFromIssuers();
        const isOIDCEnabled = systemConfigService.isOidcEnabled();
        const isOktaEnabled = systemConfigService.isOktaEnabled();
        return issuerLink && isOIDCEnabled && isOktaEnabled;
    };
    const handleLogout = async () => {
        const isRedirectFlagEnabled = sessionService.shouldLogoutWithRedirect();
        if (triggerV1Logout) {
            triggerV1Logout();
        }
        else {
            setLast401Path(currentPath);
            const orgPerUrlEnabled = sessionService.isOrgPerUrlEnabled();
            const issuerLink = systemConfigService.getOidcLoginUriFromIssuers();
            if (shouldDoIAMv2Logout() && !isPartitionedCookieEnabled()) {
                markManuallyLoggedOut();
                const { origin } = new URL(issuerLink);
                window.location.replace(`${origin}/signin?clearSession=true`);
            }
            else {
                await doLogout();
                setSessionInfo(null);
                clearSessionInfo();
                if (!shouldDoIAMv2Logout()) {
                    markManuallyLoggedOut();
                    getOnUserLoggedOut().publish();
                }
                if (orgPerUrlEnabled &&
                    window.location.href.includes('orgId')) {
                    const currentPathBeforeHash = `${window.location.href.split('#')[0]}#`;
                    let path = `${currentPathBeforeHash}`;
                    path = removeOverrideOrgId(path);
                    window.location.replace(path);
                    goToLogin();
                }
                else if (shouldDoIAMv2Logout() && isRedirectFlagEnabled) {
                    const { origin } = new URL(issuerLink);
                    const targetUrl = encodeURIComponent(`https://${window.location.hostname}`);
                    window.location.replace(`${origin}/signin?clearSession=true&targetUrl=${targetUrl}`);
                }
                else {
                    goToLogin();
                }
            }
        }
    };
    useEffect(() => {
        if (error) {
            logger.error(error);
        }
    }, [error]);
    return (React.createElement(BlinkErrorBoundary, { handledErrors: ['*'] },
        React.createElement(UserMenuV3, { hasProfilePic: hasProfilePic, collectEvent: metricsService.collectEvent, goToUserPreference: goToUserPreference, getUserDisplayName: getUserDisplayName, handleLogout: handleLogout, getUserGuid: getUserGuid, onMenuClose: onMenuClose, userEmail: sessionService.getUserEmail(), isOrgEnabled: isOrgEnabled, inviteTeammates: inviteTeammates })));
};
//# sourceMappingURL=user-menu.container.js.map